<template>
  <div class="mm-page-main">
    <el-form ref="form" :model="form" :rules="rules" label-width="130px" label-position="left">
      <div class="page-header">
        <div class="page-title">添加銀行賬號</div>
        <div @click="pageback" class="page-back">
          <svg class="icon svg-icon" aria-hidden="true">
            <use xlink:href="#icon-back"></use>
          </svg>
        </div>
      </div>
      <el-tabs v-model="tabsindex" @tab-click="changetabs">
        <el-tab-pane label="賬戶信息" name="0">
          <div class="radio-group-box">
            <div>
              <el-radio-group @change="changearea" v-model="area">
                <el-radio-button label="0">港幣</el-radio-button>
                <el-radio-button label="1">人民幣</el-radio-button>
                <el-radio-button label="2">外幣</el-radio-button>
              </el-radio-group>
            </div>
          </div>
          <component :form="form" :is="bankform"></component>
        </el-tab-pane>
        <el-tab-pane label="戶主信息" name="1">
          <accountholder :form="form"></accountholder>
        </el-tab-pane>
        <el-tab-pane label="電話卡" name="2">
          <accountphone :form="form"></accountphone>
        </el-tab-pane>

      </el-tabs>
      <div class="form-submit">
        <el-button @click="formsubmit('form')" type="primary">提交</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
import hkbankform from './components/HKBankForm.vue';
import cnbankform from './components/CNBankForm.vue';
import enbankform from './components/ENBankForm.vue';
import accountholder from './components/AccountHolder.vue';
import accountphone from './components/AccountPhone.vue';

export default {
  components: {
    hkbankform,
    cnbankform,
    enbankform,
    accountholder,
    accountphone,

  },
  data () {
    return {
      form: {
        mso_id: 0,
        area: 0,
        account_num: '',
        account_num_format: '',
        account_name: '',
        currency_id: 2,
        status: true,
        hkbank_id: 0,
        bankname: '',
        bankinfo: "",
        addtime: '',
        balance: '0.00',
        province_id: "", // 省份
        city_id: "", // 城市
        branch_id: "", // 支行名稱
        branch_name: "", // 支行名稱自定義
        holder: {
          code: '',
          name: '',
          card: '',
          phone: '',
          holderman: '',
          holder_phone: '',
          agentman: '',
          agent_phone: '',
          cardtype: '0',
          usb: '0',
          buytype: '0',
          endtime: '',
          tipstime: '',
          startrent_time: '',
          endrent_time: '',
          remarks:'',
        },
        phones: {
          code: '',
          phone: '',
          service: '',
          endtime: '',
          money: '',
          remarks:'',
        }

      },
      rules: {
        account_num: [{
          required: true,
          message: '請填寫賬號號碼',
        }, {
          pattern: /^[0-9\-]+$/,
          message: '只能輸入數字和-'
        }],
        account_name: [{
          required: true,
          message: '請填寫賬號持有人名稱',
        }],
        swift_code: [{
          required: true,
          message: '請填寫SWIFT CODE',
        }],
        country_id: [{
          required: true,
          message: '請選擇國家/地區',
        }
        ],
        bankname: [{
          required: true,
          message: '請選擇或填寫銀行名稱',
          trigger: 'change'
        }],
        balance: [{
          required: true,
          message: '請填寫餘額',
        }, {
          pattern: /^[0-9\.]+$/,
          message: '只能輸入整數和小數'
        }],
        'holder.name': [{
          required: true,
          message: '請輸入戶主姓名',
        }
        ],
        'holder.card': [{
          required: true,
          message: '請輸入身份證卡號',
        },
        ],
        'holder.phone': [{
          required: true,
          message: '請填寫電話號碼',
        }, {
          pattern: /^[0-9,，]+$/,
          message: '只能輸入數字和“,”'
        }],
        'holder.holderman': [],
        'holder.holder_phone': [{
          pattern: /^[0-9,，]+$/,
          message: '只能輸入數字和“,”'
        }],
        'holder.agentman': [],
        'holder.agent_phone': [{
          pattern: /^[0-9,，]+$/,
          message: '只能輸入數字和“,”'
        }],

        'phones.phone': [{
          required: true,
          message: '請填寫電話號碼',
        }, {
          pattern: /^[0-9]+$/,
          message: '只能輸入數字'
        }],
        // 'phones.endtime': [{
        //   required: true,
        //   message: '請選擇到期日期',
        // }],
        'phones.money': [{
          required: true,
          message: '請填寫餘額',
        }, {
          pattern: /^[0-9\.]+$/,
          message: '只能輸入數字和小數'
        }]


      },
      tabsindex: '0',
      area: 0,
      bankform: 'hkbankform'
    };
  },
  methods: {
    changetabs (tab, event) {

    },
    pageback () {
      this.$router.go(-1);
    },
    changearea () {
      this.form.bankname = '';
      this.form.hkbank_id = '';
      this.form.cnbank_id = '';
      let area = this.area;
      if (area == 0) {
        this.bankform = 'hkbankform';
      } else if (area == 1) {
        this.bankform = 'cnbankform';
      } else if (area == 2) {
        this.bankform = 'enbankform';
      }
    },
    formsubmit (form) {

      this.$refs[form].validate((valid) => {
        if (valid) {
          this.form.area = this.area;
          let data = this.form;

          this.loading = true;
          this.post('/api/bank/bank_account_save', {
            data: data
          }).then((res) => {

            if (res == 'success') {
              this.$message({
                showClose: true,
                message: '添加銀行賬號成功！',
                type: 'success',
                onClose: (() => {
                })
              });
              this.pageback();
            } else {
              this.$message({
                showClose: true,
                message: '添加銀行賬號失敗，請重試！',
                type: 'error',

              });
            }

            this.loading = false;
          }).catch((err) => {
            this.loading = false;
            console.log(err)
          });
        } else {
          this.$message({
            showClose: true,
            message: '請填寫賬戶信息，戶主信息，電話卡等必填字段後提交！',
            type: 'error',

          });
        }
      });
    },

  },
  created () {
    this.form.mso_id = this.sessionRead('mso_id');
  }

};
</script>
<style scoped>
.el-tabs__content {
  overflow: auto;
}
</style>
